import { render } from "./ImagePreview.vue?vue&type=template&id=7bfac20e&scoped=true"
import script from "./ImagePreview.vue?vue&type=script&lang=ts"
export * from "./ImagePreview.vue?vue&type=script&lang=ts"

import "./ImagePreview.vue?vue&type=style&index=0&id=7bfac20e&lang=less&scoped=true"
import "./ImagePreview.vue?vue&type=style&index=1&id=7bfac20e&lang=less"
script.render = render
script.__scopeId = "data-v-7bfac20e"

export default script